const TwoFactorAuthTroubleEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthHavingTrouble',
  Object: 'Container',
  Action: 'Viewed',
  object_name: 'twoFactorAuthHavingTrouble',
  screen: 'twoFactorAuthHavingTrouble',
  screen_name: 'twoFactorAuthHavingTrouble',
}

const ScreenViewedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'twoFactorAuthEnterCode',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
  origin: 'PhoneNumber',
}

const MfaLandingScreenViewedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'twoFactorAuthEnterCode',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
}

const MfaChallengeScreenViewedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'twoFactorAuthEnterCode',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
}

const MfaVerifyScreenViewedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'twoFactorAuthEnterCode',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
}

const CodeSubmittedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Destination: 'TwoFactorAuthConfirm',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'twoFactorAuthEnterCode',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
  cta_title: 'Confirm',
}

const ChallengeInitiatedEvent = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthEnterCode',
  Destination: 'TwoFactorAuthConfirm',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'twoFactorAuthChallengeInitiated',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
}

const AuthConfirmEvent = {
  feature: 'twoFactorAuth',
  event_description: 'TwoFactorAuthConfirm',
  Object: 'Container',
  Action: 'Viewed',
  object_name: 'TwoFactorAuthEnterConfirm',
  screen: 'twoFactorAuthEnterCode',
  screen_name: 'twoFactorAuthEnterCode',
}

const AuthSuccessEvent = {
  Feature: 'phoneNumber',
  event_description: 'twoFactorAuthPhoneNumberUpdated',
  Object: 'Container',
  Action: 'Viewed',
  object_name: 'twoFactorAuthPhoneNumberUpdated',
  screen: 'phoneNumber',
  screen_name: 'phoneNumber',
}

const ScreenViewedEventPhone = (origin = 'personalInfo') => ({
  feature: 'phoneNumber',
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'phoneNumber',
  screen: 'phoneNumber',
  screen_name: 'phoneNumber',
  origin,
})

const NextButtonTapped = {
  feature: 'phoneNumber',
  event_description: 'phoneNumber',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'phoneNumber',
  screen: 'phoneNumber',
  screen_name: 'phoneNumber',
  cta_title: 'Next',
}

const HelpButtonTapped = {
  feature: 'twoFactorAuth',
  event_description: 'twoFactorAuthHelp button tapped',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'twoFactorAuthHelp',
  screen: 'twoFactorAuth',
  screen_name: 'twoFactorAuth',
  cta_title: 'Help',
}

const HelpModalContainerViewed = {
  feature: 'MFA Need Help Modal',
  event_description: 'twoFactorAuthHelpModal container viewed',
  Object: 'Container',
  Action: 'Viewed',
  object_name: 'twoFactorAuthHelpModal',
  screen: 'mfaNeedHelpModal',
  screen_name: 'mfaNeedHelpModal',
}

const HelpModalCotactSupportButtonTapped = {
  feature: 'MFA Need Help Modal',
  event_description: 'twoFactorAuthHelpModalContactSupport button tapped',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'twoFactorAuthHelpModalContactSupport',
  screen: 'mfaNeedHelpModal',
  screen_name: 'mfaNeedHelpModal',
  cta_title: 'Contact Support',
}

const HelpModalOkButtonTapped = {
  feature: 'MFA Need Help Modal',
  event_description: 'twoFactorAuthHelpModalOk button tapped',
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'twoFactorAuthHelpModalOk',
  screen: 'mfaNeedHelpModal',
  screen_name: 'mfaNeedHelpModal',
  cta_title: 'Ok',
}

export {
  AuthConfirmEvent,
  AuthSuccessEvent,
  ChallengeInitiatedEvent,
  HelpButtonTapped,
  MfaLandingScreenViewedEvent,
  MfaChallengeScreenViewedEvent,
  MfaVerifyScreenViewedEvent,
  NextButtonTapped,
  ScreenViewedEvent,
  ScreenViewedEventPhone,
  CodeSubmittedEvent,
  TwoFactorAuthTroubleEvent,
  HelpModalCotactSupportButtonTapped,
  HelpModalOkButtonTapped,
  HelpModalContainerViewed,
}
